import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EditionSearch } from '@features/models/events/editions/edition-search';
import { map, Observable } from 'rxjs';

@Injectable()
export class WhatsOnService {

  private _whatsOnUrl = '/whatson'; 

  private _http = inject(HttpClient);

  constructor() { }

  getWhatsOnData(): Observable<EditionSearch> {
    return this._http.get<EditionSearch>(this._whatsOnUrl);
  }

}
